<template lang="pug">
  .component-billed-records
    table
      thead
        tr
          th Id
          th Driver Id
          th Type & Id
          th Tax
          th Tax Rate
          th Amount
      tbody
        tr(v-for="item in item.records")
          td {{item.id}}
          td {{item.driver_id}}
          td {{item.walletable_type | walletableType}} - {{item.walletable_id}}

          td {{$priceWithcurrency(parseFloat(item.amount * item.tax).toFixed(2))}}
          td {{-item.tax*100}}%
          td {{$priceWithcurrency(-item.amount)}}
</template>

<script>
  export default {
    name: 'BilledRecords',
    methods: {},
    filters: {
      walletableType(value) {
        return value.replace(/App\\Models\\/, '')
      }
    },
    props: ['item']
  }
</script>

<style lang="sass">
  .component-billed-records

</style>



// WEBPACK FOOTER //
// BilledRecords.vue?50e93927